import React, { useEffect, useRef } from 'react';
import Banner from '@pattern-library/banner';
import PropTypes from 'prop-types';

const propTypes = {
    type: PropTypes.string.isRequired,
    ariaRole: PropTypes.string.isRequired,
    autoFocus: PropTypes.bool,
    hasCloseButton: PropTypes.bool,
    inline: PropTypes.bool,
    message: PropTypes.string.isRequired,
    isGlobalBanner: PropTypes.bool
};

const defaultProps = {
    inline: true,
    hasCloseButton: false,
    ariaRole: 'alert',
    autoFocus: false,
    isGlobalBanner: false
};
function LoginBanner(props) {
    const { message, isGlobalBanner, autoFocus, ...rest } = props;
    const bannerRef = useRef();

    const hasHtml = /<[^>]*>/g.test(message); // Check for html in the string

    const globalBanner = hasHtml ? (
        <div
            className="ul-banner--message asc-mb-0"
            dangerouslySetInnerHTML={{ __html: message }}
        />
    ) : (
        <p className="ul-banner--message asc-mb-0">{message}</p>
    );

    const formBanner = hasHtml ? (
        <div
            className="ul-banner--message asc-p--small asc-mb-0"
            dangerouslySetInnerHTML={{ __html: message }}
        />
    ) : (
        <p className="ul-banner--message asc-p--small asc-mb-0">{message}</p>
    );

    useEffect(() => {
        if (autoFocus) {
            bannerRef.current?.focus();
        }
    }, [autoFocus]);

    return (
        <Banner
            customClass={isGlobalBanner ? 'ul-banner--container' : ''}
            customAttrs={{ ref: bannerRef, tabIndex: autoFocus ? '-1' : undefined }}
            messageRichText={isGlobalBanner ? globalBanner : formBanner}
            {...rest}
        />
    );
}

LoginBanner.propTypes = propTypes;
LoginBanner.defaultProps = defaultProps;
export default LoginBanner;
